/* eslint-disable jsx-a11y/label-has-for */

import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import classnames from "classnames";

const placeholders = {
	"&mdash;": 1,
	"—": 1,
	"Select one": 1,
	"Pick one": 1,
};

const _prepName = (_name) => {
	let name = _name;

	if (name === "&mdash;") {
		name = "—";
	}

	if (name && typeof (name) === "string") {
		name = name.replace("&nbsp;", " ");
	}

	return name;
};

const prepNameFromOption = (option) => _prepName(option.name);

const OkSelect = (props) => {
	const _getAllOptions = () => {
		const allOptions = [];

		props.options.forEach((option) => {
			if (option.title) {
				option.options.forEach((groupOption) => {
					allOptions.push(groupOption);
				});
			} else {
				allOptions.push(option);
			}
		});

		return allOptions;
	};

	const _getActiveOption = () => {
		const allOptions = _getAllOptions();
		let activeOption;
		let value;

		if (props.value || props.value === 0) {
			activeOption = allOptions.filter((option) => {
				value = String(props.value);

				if (value === "—" || value === null) {
					value = "&mdash;";
				}

				return String(option.value) === value;
			});

			if (activeOption.length) {
				activeOption = activeOption[0];
			}
		} else if (props.options.length) {
			if (props.options[0].title) {
				activeOption = props.options[0].options[0];
			} else {
				activeOption = props.options[0];
			}
		}

		return activeOption;
	};

	const _getIsPlaceholder = () => {
		const activeOption = _getActiveOption();

		if (activeOption === null || typeof (activeOption) === "undefined") {
			return false;
		}

		let isPlaceholder = false;

		if (placeholders[activeOption.name]) {
			isPlaceholder = true;
		}

		if (activeOption.placeholder) {
			isPlaceholder = true;
		}

		if (activeOption.disabled) {
			isPlaceholder = true;
		}

		return isPlaceholder;
	};

	const _clear = (e) => {
		e.preventDefault();

		if (props.onClear) {
			props.onClear();
		}
	};

	const isPlaceholder = _getIsPlaceholder();

	const selectClasses = {
		"oknf-select": true,
		"oknf-select--disabled": props.disabled,
	};

	const spanClasses = {
		"oknf-select-active": true,
		"oknf-select-active--placeholder": isPlaceholder,
	};

	if (props.className) {
		selectClasses[props.className] = true;
	}

	let name;
	const activeOption = _getActiveOption();

	if (activeOption && activeOption.name) {
		name = props.formatActiveValue(activeOption);
	}

	return (
		<label className={classnames(selectClasses)}>
			<span className={classnames(spanClasses)}>
				{name}
			</span>

			{props.onClear && !isPlaceholder &&
				<button className="oknf-select-clear" onClick={_clear}>
					<span className="oknf-select-clear-text">clear</span>
				</button>
			}

			<select
				disabled={props.disabled}
				name={props.name}
				onChange={props.onChange}
				value={props.value} >

				{props.options.map((option) => {
					if (option.title) {
						return (
							<optgroup
								key={`${option.title}-${option.value}`}
								label={option.title}
							>
								{option.options.map((groupOption) => {
									return (
										<option
											value={groupOption.value}
											key={`${option.value}-${groupOption.value}`}
										>
											{_prepName(groupOption.name)}
										</option>
									);
								})}
							</optgroup>
						);
					} else {
						return (
							<option
								value={option.value}
								key={`${option.name}-${option.value}`}
								disabled={option.disabled}
							>
								{_prepName(option.name)}
							</option>
						);
					}
				})}

			</select>
		</label>
	);
};

OkSelect.propTypes = {
	options: PropTypes.array.isRequired,
	name: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
	value: PropTypes.node,
	onChange: PropTypes.func,
	onClear: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	formatActiveValue: PropTypes.func,
};

OkSelect.defaultProps = {
	name: null,
	value: "",
	onChange: noop,
	onClear: null,
	className: null,
	disabled: false,
	formatActiveValue: prepNameFromOption,
};

export default OkSelect;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/OkSelect.jsx